/**
 * Whereby Rerun (Admin) Handlers
 *
 * Dev-only tooling for re-queueing Whereby transcription tasks by team.
 */

import { handleRequest } from './config'
import { State } from '../../hooks/useAppState'
import { loadCloudFunctionsHandler } from '../handlers'
import type { ApiResponse } from '../types'
import type {
  ListTeamsForWherebyRerunRequest,
  ListTeamsForWherebyRerunResponse,
  RerunWherebyTasksForTeamIdsRequest,
  RerunWherebyTasksForTeamIdsResponse
} from '../../../../pure-js/types/WherebyRerun'

export const listTeamsForWherebyRerun = async (
  req: ListTeamsForWherebyRerunRequest,
  state: State
): Promise<ApiResponse<ListTeamsForWherebyRerunResponse>> => {
  return handleRequest(
    () => {
      const empty: ListTeamsForWherebyRerunResponse = { teams: [] }
      const mock: ApiResponse<ListTeamsForWherebyRerunResponse> = { data: empty, success: true }
      return Promise.resolve(mock)
    },
    async () => {
      const cloudFunctions = await loadCloudFunctionsHandler()
      return cloudFunctions.listTeamsForWherebyRerun(req, state)
    }
  )
}

export const rerunWherebyTasksForTeamIds = async (
  req: RerunWherebyTasksForTeamIdsRequest,
  state: State
): Promise<ApiResponse<RerunWherebyTasksForTeamIdsResponse>> => {
  return handleRequest(
    () => {
      const empty: RerunWherebyTasksForTeamIdsResponse = {
        ok: true,
        dryRun: !!req.dryRun,
        totalTeams: req.teamIds?.length ?? 0,
        totalRoomNames: 0,
        totalMatchedTasks: 0,
        totalResetTasks: 0,
        teams: []
      }

      const mock: ApiResponse<RerunWherebyTasksForTeamIdsResponse> = { data: empty, success: true }
      return Promise.resolve(mock)
    },
    async () => {
      const cloudFunctions = await loadCloudFunctionsHandler()
      return cloudFunctions.rerunWherebyTasksForTeamIds(req, state)
    }
  )
}
